// extracted by mini-css-extract-plugin
export var button = "about-section-module--button--4Hub0";
export var container = "about-section-module--container--WE91E";
export var content = "about-section-module--content--wlTso";
export var secondary = "about-section-module--secondary--a1yel";
export var subtitle = "about-section-module--subtitle--GVXHz";
export var test = "about-section-module--test--A-oKN";
export var text = "about-section-module--text--zrEL5";
export var title = "about-section-module--title--+BXwJ";